import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I am an experienced Javascript, React developer & Unity game developer.`}</p>
    <h4>{`Skills`}</h4>
    <ul>
      <li parentName="ul">{`HTML, CSS, JavaScript`}</li>
      <li parentName="ul">{`React, Vue, Svelte`}</li>
      <li parentName="ul">{`Node.js, Express, Postgres, MongoDB`}</li>
      <li parentName="ul">{`C#, Unity, VR, AR`}</li>
      <li parentName="ul">{`Python, Flask, Django`}</li>
      <li parentName="ul">{`Docker, Firebase`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      